const observerOptions = {
  root: null,
  rootMargin: '0px 0px -15% 0px',
  threshold: 0.15,
};

const animationObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    const section = entry.target;
    if (!(section instanceof HTMLElement)) return;

    if (entry.isIntersecting) {
      section.classList.add('heading-animation--active');
    } else {
      section.classList.remove('heading-animation--active');
    }
  });
}, observerOptions);

function shouldObserveSection(section) {
  return (
    section instanceof HTMLElement &&
    section.dataset.headingAnimation &&
    section.dataset.headingAnimation !== 'none'
  );
}

function initHeadingAnimations(root = document) {
  const scope = root instanceof HTMLElement || root instanceof DocumentFragment ? root : document;
  const sections = scope.querySelectorAll('.section[data-heading-animation]:not([data-heading-animation="none"])');

  sections.forEach((section) => {
    if (section.dataset.headingAnimationObserver === 'true') {
      return;
    }

    section.dataset.headingAnimationObserver = 'true';
    animationObserver.observe(section);
  });
}

function cleanupHeadingAnimation(event) {
  const section = event.target;
  if (section instanceof HTMLElement && shouldObserveSection(section)) {
    animationObserver.unobserve(section);
    section.dataset.headingAnimationObserver = 'false';
    section.classList.remove('heading-animation--active');
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initHeadingAnimations());
} else {
  initHeadingAnimations();
}

document.addEventListener('shopify:section:load', (event) => {
  initHeadingAnimations(event.target);
});

document.addEventListener('shopify:section:unload', cleanupHeadingAnimation);

